var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rkm-modal',{ref:"RkmModal",attrs:{"extra-large":"","hide-footer":"","title":"Lista de cidadãos com cadastro desatualizado"}},[_c('List',{attrs:{"readonly-mode":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }